//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class EmailTemplateClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/.";
    }

    get(): Promise<PlantillaCorreo[]> {
        let url_ = this.baseUrl + "/api/EmailTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<PlantillaCorreo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlantillaCorreo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlantillaCorreo[]>(null as any);
    }
}

export class RespuestasPredeterminadasClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/.";
    }

    getAll(transitionId: number): Promise<RespuestaPredeterminada[]> {
        let url_ = this.baseUrl + "/api/transitions/{transitionId}/RespuestasPredeterminadas";
        if (transitionId === undefined || transitionId === null)
            throw new Error("The parameter 'transitionId' must be defined.");
        url_ = url_.replace("{transitionId}", encodeURIComponent("" + transitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<RespuestaPredeterminada[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RespuestaPredeterminada.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RespuestaPredeterminada[]>(null as any);
    }

    post(transitionId: number, model: RespuestaPredeterminada): Promise<RespuestaPredeterminada> {
        let url_ = this.baseUrl + "/api/transitions/{transitionId}/RespuestasPredeterminadas";
        if (transitionId === undefined || transitionId === null)
            throw new Error("The parameter 'transitionId' must be defined.");
        url_ = url_.replace("{transitionId}", encodeURIComponent("" + transitionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<RespuestaPredeterminada> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RespuestaPredeterminada.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RespuestaPredeterminada>(null as any);
    }

    get(transitionId: number, id: number): Promise<RespuestaPredeterminada> {
        let url_ = this.baseUrl + "/api/transitions/{transitionId}/RespuestasPredeterminadas/{id}";
        if (transitionId === undefined || transitionId === null)
            throw new Error("The parameter 'transitionId' must be defined.");
        url_ = url_.replace("{transitionId}", encodeURIComponent("" + transitionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<RespuestaPredeterminada> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RespuestaPredeterminada.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RespuestaPredeterminada>(null as any);
    }

    put(transitionId: number, id: number, model: RespuestaPredeterminada): Promise<RespuestaPredeterminada> {
        let url_ = this.baseUrl + "/api/transitions/{transitionId}/RespuestasPredeterminadas/{id}";
        if (transitionId === undefined || transitionId === null)
            throw new Error("The parameter 'transitionId' must be defined.");
        url_ = url_.replace("{transitionId}", encodeURIComponent("" + transitionId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<RespuestaPredeterminada> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RespuestaPredeterminada.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RespuestaPredeterminada>(null as any);
    }

    delete(id: number, transitionId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/transitions/{transitionId}/RespuestasPredeterminadas/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (transitionId === undefined || transitionId === null)
            throw new Error("The parameter 'transitionId' must be defined.");
        url_ = url_.replace("{transitionId}", encodeURIComponent("" + transitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class StagesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/.";
    }

    getParaPlantilla(plantillaId: number): Promise<Stage[]> {
        let url_ = this.baseUrl + "/plantilla/{plantillaId}";
        if (plantillaId === undefined || plantillaId === null)
            throw new Error("The parameter 'plantillaId' must be defined.");
        url_ = url_.replace("{plantillaId}", encodeURIComponent("" + plantillaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParaPlantilla(_response);
        });
    }

    protected processGetParaPlantilla(response: Response): Promise<Stage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Stage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Stage[]>(null as any);
    }

    get(id: number): Promise<Stage> {
        let url_ = this.baseUrl + "/api/Stages/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Stage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Stage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Stage>(null as any);
    }

    put(id: number, model: Stage): Promise<void> {
        let url_ = this.baseUrl + "/api/Stages/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Stages/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    post(model: Stage): Promise<Stage> {
        let url_ = this.baseUrl + "/api/Stages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Stage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Stage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Stage>(null as any);
    }
}

export class TransitionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/.";
    }

    getParaPlantilla(plantillaId: number): Promise<Transition[]> {
        let url_ = this.baseUrl + "/api/Transitions/paraPlantilla/{plantillaId}";
        if (plantillaId === undefined || plantillaId === null)
            throw new Error("The parameter 'plantillaId' must be defined.");
        url_ = url_.replace("{plantillaId}", encodeURIComponent("" + plantillaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParaPlantilla(_response);
        });
    }

    protected processGetParaPlantilla(response: Response): Promise<Transition[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Transition.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Transition[]>(null as any);
    }

    get(id: number): Promise<Transition> {
        let url_ = this.baseUrl + "/api/Transitions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Transition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Transition.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Transition>(null as any);
    }

    put(id: number, model: Transition): Promise<Transition> {
        let url_ = this.baseUrl + "/api/Transitions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<Transition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Transition.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Transition>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Transitions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    post(model: Transition): Promise<Transition> {
        let url_ = this.baseUrl + "/api/Transitions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Transition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Transition.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Transition>(null as any);
    }
}

export class UserAndRolesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/.";
    }

    users(username: string | null | undefined): Promise<Select2Result> {
        let url_ = this.baseUrl + "/api/UserAndRoles/users?";
        if (username !== undefined && username !== null)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUsers(_response);
        });
    }

    protected processUsers(response: Response): Promise<Select2Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Select2Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Select2Result>(null as any);
    }

    roles(nombre: string | null | undefined): Promise<Select2Result> {
        let url_ = this.baseUrl + "/api/UserAndRoles/roles?";
        if (nombre !== undefined && nombre !== null)
            url_ += "nombre=" + encodeURIComponent("" + nombre) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRoles(_response);
        });
    }

    protected processRoles(response: Response): Promise<Select2Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Select2Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Select2Result>(null as any);
    }

    descripcionRoles(ids: string | null | undefined): Promise<Select2Result> {
        let url_ = this.baseUrl + "/api/UserAndRoles/DescripcionRoles?";
        if (ids !== undefined && ids !== null)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDescripcionRoles(_response);
        });
    }

    protected processDescripcionRoles(response: Response): Promise<Select2Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Select2Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Select2Result>(null as any);
    }

    descripcionUsuarios(ids: string | null | undefined): Promise<Select2Result> {
        let url_ = this.baseUrl + "/api/UserAndRoles/descipcionUsuarios?";
        if (ids !== undefined && ids !== null)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDescripcionUsuarios(_response);
        });
    }

    protected processDescripcionUsuarios(response: Response): Promise<Select2Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Select2Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Select2Result>(null as any);
    }

    usuariosPorRol(id: number | undefined): Promise<Select2Result> {
        let url_ = this.baseUrl + "/api/UserAndRoles/usuariosPorRol?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUsuariosPorRol(_response);
        });
    }

    protected processUsuariosPorRol(response: Response): Promise<Select2Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Select2Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Select2Result>(null as any);
    }
}

export class WorkFlowChartClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/.";
    }

    get(plantillaId: number): Promise<string> {
        let url_ = this.baseUrl + "/api/WorkFlowChart/{plantillaId}";
        if (plantillaId === undefined || plantillaId === null)
            throw new Error("The parameter 'plantillaId' must be defined.");
        url_ = url_.replace("{plantillaId}", encodeURIComponent("" + plantillaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class WebhookConfigurationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/.";
    }

    getAll(): Promise<WebhookConfiguration[]> {
        let url_ = this.baseUrl + "/api/WebhookConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<WebhookConfiguration[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebhookConfiguration.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebhookConfiguration[]>(null as any);
    }

    post(model: WebhookConfigurationCreateDto): Promise<WebhookConfiguration> {
        let url_ = this.baseUrl + "/api/WebhookConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<WebhookConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebhookConfiguration.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebhookConfiguration>(null as any);
    }

    get(id: string): Promise<WebhookConfiguration> {
        let url_ = this.baseUrl + "/api/WebhookConfigurations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<WebhookConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebhookConfiguration.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebhookConfiguration>(null as any);
    }

    put(id: string, model: WebhookConfigurationUpdateDto): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/WebhookConfigurations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    delete(id: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/WebhookConfigurations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    summarization(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/WebhookConfigurations/summarization";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSummarization(_response);
        });
    }

    protected processSummarization(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class PlantillaCorreo implements IPlantillaCorreo {
    id!: number;
    nombre!: string;
    contenidoHtml!: string;
    estaDisponible!: boolean;
    transition?: Transition | undefined;
    asunto?: string | undefined;
    destinatario?: string | undefined;
    destinatarioTelefono?: string | undefined;
    tipoNotificacion!: TipoNotificacion;
    tipoDestinatario!: DestinatarioEnum;

    constructor(data?: IPlantillaCorreo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nombre = _data["nombre"];
            this.contenidoHtml = _data["contenidoHtml"];
            this.estaDisponible = _data["estaDisponible"];
            this.transition = _data["transition"] ? Transition.fromJS(_data["transition"]) : <any>undefined;
            this.asunto = _data["asunto"];
            this.destinatario = _data["destinatario"];
            this.destinatarioTelefono = _data["destinatarioTelefono"];
            this.tipoNotificacion = _data["tipoNotificacion"];
            this.tipoDestinatario = _data["tipoDestinatario"];
        }
    }

    static fromJS(data: any): PlantillaCorreo {
        data = typeof data === 'object' ? data : {};
        let result = new PlantillaCorreo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nombre"] = this.nombre;
        data["contenidoHtml"] = this.contenidoHtml;
        data["estaDisponible"] = this.estaDisponible;
        data["transition"] = this.transition ? this.transition.toJSON() : <any>undefined;
        data["asunto"] = this.asunto;
        data["destinatario"] = this.destinatario;
        data["destinatarioTelefono"] = this.destinatarioTelefono;
        data["tipoNotificacion"] = this.tipoNotificacion;
        data["tipoDestinatario"] = this.tipoDestinatario;
        return data;
    }
}

export interface IPlantillaCorreo {
    id: number;
    nombre: string;
    contenidoHtml: string;
    estaDisponible: boolean;
    transition?: Transition | undefined;
    asunto?: string | undefined;
    destinatario?: string | undefined;
    destinatarioTelefono?: string | undefined;
    tipoNotificacion: TipoNotificacion;
    tipoDestinatario: DestinatarioEnum;
}

export class Transition implements ITransition {
    id!: number;
    fromId!: number;
    toId!: number;
    description?: string | undefined;
    isDeleted!: boolean;
    disabled!: boolean;
    tipoTransicion!: TransitionType;
    to?: Stage | undefined;
    from?: Stage | undefined;
    isAutomatic!: boolean;
    allowFiles!: boolean;
    plantillaCorreo?: PlantillaCorreo | undefined;
    plantillaCorreoId?: number | undefined;

    constructor(data?: ITransition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fromId = _data["fromId"];
            this.toId = _data["toId"];
            this.description = _data["description"];
            this.isDeleted = _data["isDeleted"];
            this.disabled = _data["disabled"];
            this.tipoTransicion = _data["tipoTransicion"];
            this.to = _data["to"] ? Stage.fromJS(_data["to"]) : <any>undefined;
            this.from = _data["from"] ? Stage.fromJS(_data["from"]) : <any>undefined;
            this.isAutomatic = _data["isAutomatic"];
            this.allowFiles = _data["allowFiles"];
            this.plantillaCorreo = _data["plantillaCorreo"] ? PlantillaCorreo.fromJS(_data["plantillaCorreo"]) : <any>undefined;
            this.plantillaCorreoId = _data["plantillaCorreoId"];
        }
    }

    static fromJS(data: any): Transition {
        data = typeof data === 'object' ? data : {};
        let result = new Transition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromId"] = this.fromId;
        data["toId"] = this.toId;
        data["description"] = this.description;
        data["isDeleted"] = this.isDeleted;
        data["disabled"] = this.disabled;
        data["tipoTransicion"] = this.tipoTransicion;
        data["to"] = this.to ? this.to.toJSON() : <any>undefined;
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        data["isAutomatic"] = this.isAutomatic;
        data["allowFiles"] = this.allowFiles;
        data["plantillaCorreo"] = this.plantillaCorreo ? this.plantillaCorreo.toJSON() : <any>undefined;
        data["plantillaCorreoId"] = this.plantillaCorreoId;
        return data;
    }
}

export interface ITransition {
    id: number;
    fromId: number;
    toId: number;
    description?: string | undefined;
    isDeleted: boolean;
    disabled: boolean;
    tipoTransicion: TransitionType;
    to?: Stage | undefined;
    from?: Stage | undefined;
    isAutomatic: boolean;
    allowFiles: boolean;
    plantillaCorreo?: PlantillaCorreo | undefined;
    plantillaCorreoId?: number | undefined;
}

export enum TransitionType {
    ABIERTA = 0,
    APROBADA = 1,
    RECHAZADA = 2,
    CERRADA = 3,
}

export class Stage implements IStage {
    id!: number;
    name?: string | undefined;
    cssIcon?: string | undefined;
    nameAndTemplate?: string | undefined;
    isDeleted!: boolean;
    disabled!: boolean;
    isFinal!: boolean;
    isStart!: boolean;
    isEditable!: boolean;
    plantillaFormularioId!: number;
    responsible?: string | undefined;
    responsiblesInGroup?: string | undefined;
    urlServicio?: string | undefined;
    plantillaFormulario?: PlantillaFormulario | undefined;
    strategy!: Strategy;
    from?: Transition[] | undefined;
    to?: Transition[] | undefined;
    webhookConfiguration?: WebhookConfiguration[] | undefined;
    tipoLista!: TipoLista;
    rol?: string | undefined;

    constructor(data?: IStage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.cssIcon = _data["cssIcon"];
            this.nameAndTemplate = _data["nameAndTemplate"];
            this.isDeleted = _data["isDeleted"];
            this.disabled = _data["disabled"];
            this.isFinal = _data["isFinal"];
            this.isStart = _data["isStart"];
            this.isEditable = _data["isEditable"];
            this.plantillaFormularioId = _data["plantillaFormularioId"];
            this.responsible = _data["responsible"];
            this.responsiblesInGroup = _data["responsiblesInGroup"];
            this.urlServicio = _data["urlServicio"];
            this.plantillaFormulario = _data["plantillaFormulario"] ? PlantillaFormulario.fromJS(_data["plantillaFormulario"]) : <any>undefined;
            this.strategy = _data["strategy"];
            if (Array.isArray(_data["from"])) {
                this.from = [] as any;
                for (let item of _data["from"])
                    this.from!.push(Transition.fromJS(item));
            }
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(Transition.fromJS(item));
            }
            if (Array.isArray(_data["webhookConfiguration"])) {
                this.webhookConfiguration = [] as any;
                for (let item of _data["webhookConfiguration"])
                    this.webhookConfiguration!.push(WebhookConfiguration.fromJS(item));
            }
            this.tipoLista = _data["tipoLista"];
            this.rol = _data["rol"];
        }
    }

    static fromJS(data: any): Stage {
        data = typeof data === 'object' ? data : {};
        let result = new Stage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["cssIcon"] = this.cssIcon;
        data["nameAndTemplate"] = this.nameAndTemplate;
        data["isDeleted"] = this.isDeleted;
        data["disabled"] = this.disabled;
        data["isFinal"] = this.isFinal;
        data["isStart"] = this.isStart;
        data["isEditable"] = this.isEditable;
        data["plantillaFormularioId"] = this.plantillaFormularioId;
        data["responsible"] = this.responsible;
        data["responsiblesInGroup"] = this.responsiblesInGroup;
        data["urlServicio"] = this.urlServicio;
        data["plantillaFormulario"] = this.plantillaFormulario ? this.plantillaFormulario.toJSON() : <any>undefined;
        data["strategy"] = this.strategy;
        if (Array.isArray(this.from)) {
            data["from"] = [];
            for (let item of this.from)
                data["from"].push(item.toJSON());
        }
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item.toJSON());
        }
        if (Array.isArray(this.webhookConfiguration)) {
            data["webhookConfiguration"] = [];
            for (let item of this.webhookConfiguration)
                data["webhookConfiguration"].push(item.toJSON());
        }
        data["tipoLista"] = this.tipoLista;
        data["rol"] = this.rol;
        return data;
    }
}

export interface IStage {
    id: number;
    name?: string | undefined;
    cssIcon?: string | undefined;
    nameAndTemplate?: string | undefined;
    isDeleted: boolean;
    disabled: boolean;
    isFinal: boolean;
    isStart: boolean;
    isEditable: boolean;
    plantillaFormularioId: number;
    responsible?: string | undefined;
    responsiblesInGroup?: string | undefined;
    urlServicio?: string | undefined;
    plantillaFormulario?: PlantillaFormulario | undefined;
    strategy: Strategy;
    from?: Transition[] | undefined;
    to?: Transition[] | undefined;
    webhookConfiguration?: WebhookConfiguration[] | undefined;
    tipoLista: TipoLista;
    rol?: string | undefined;
}

export class PlantillaFormulario implements IPlantillaFormulario {
    id!: number;
    grupoId!: number;
    nombre!: string;
    descripcion!: string;
    usuarioCreador!: string;
    fechaCreacion!: Date;
    fechaCreacionCorto?: string | undefined;
    idFormularioRoles?: number | undefined;
    estaDisponible!: boolean;
    docsPorRamo!: boolean;
    comentarios!: boolean;
    infoPoliza!: boolean;
    informacionAsegurado!: boolean;
    seccionPolizas!: boolean;
    infoPersonal!: boolean;
    borradoLogico!: boolean;
    mcaPublico!: boolean;
    accesoAnonimo!: boolean;
    cargaMasiva!: boolean;
    formularioGuid!: string;
    tipoAsignacion?: number | undefined;
    tipoAsignacionUsuarioGrupo?: number | undefined;
    urlServicio?: string | undefined;
    stages?: Stage[] | undefined;
    gruposAutocompletado?: GrupoAutocompletado[] | undefined;
    grupo?: string | undefined;
    tipoAsignacionDescripcion?: string | undefined;
    campoNombre?: string | undefined;
    campoTipDocum?: string | undefined;
    campoCodDocum?: string | undefined;
    campoEmail?: string | undefined;
    campoTelef?: string | undefined;
    disponibilidadBorradorEnDias!: number;
    permiteBorrador!: boolean;
    tituloFinalizado?: string | undefined;
    subtituloFinalizado?: string | undefined;
    checkboxAutoriza!: boolean;

    constructor(data?: IPlantillaFormulario) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.grupoId = _data["grupoId"];
            this.nombre = _data["nombre"];
            this.descripcion = _data["descripcion"];
            this.usuarioCreador = _data["usuarioCreador"];
            this.fechaCreacion = _data["fechaCreacion"] ? new Date(_data["fechaCreacion"].toString()) : <any>undefined;
            this.fechaCreacionCorto = _data["fechaCreacionCorto"];
            this.idFormularioRoles = _data["idFormularioRoles"];
            this.estaDisponible = _data["estaDisponible"];
            this.docsPorRamo = _data["docsPorRamo"];
            this.comentarios = _data["comentarios"];
            this.infoPoliza = _data["infoPoliza"];
            this.informacionAsegurado = _data["informacionAsegurado"];
            this.seccionPolizas = _data["seccionPolizas"];
            this.infoPersonal = _data["infoPersonal"];
            this.borradoLogico = _data["borradoLogico"];
            this.mcaPublico = _data["mcaPublico"];
            this.accesoAnonimo = _data["accesoAnonimo"];
            this.cargaMasiva = _data["cargaMasiva"];
            this.formularioGuid = _data["formularioGuid"];
            this.tipoAsignacion = _data["tipoAsignacion"];
            this.tipoAsignacionUsuarioGrupo = _data["tipoAsignacionUsuarioGrupo"];
            this.urlServicio = _data["urlServicio"];
            if (Array.isArray(_data["stages"])) {
                this.stages = [] as any;
                for (let item of _data["stages"])
                    this.stages!.push(Stage.fromJS(item));
            }
            if (Array.isArray(_data["gruposAutocompletado"])) {
                this.gruposAutocompletado = [] as any;
                for (let item of _data["gruposAutocompletado"])
                    this.gruposAutocompletado!.push(GrupoAutocompletado.fromJS(item));
            }
            this.grupo = _data["grupo"];
            this.tipoAsignacionDescripcion = _data["tipoAsignacionDescripcion"];
            this.campoNombre = _data["campoNombre"];
            this.campoTipDocum = _data["campoTipDocum"];
            this.campoCodDocum = _data["campoCodDocum"];
            this.campoEmail = _data["campoEmail"];
            this.campoTelef = _data["campoTelef"];
            this.disponibilidadBorradorEnDias = _data["disponibilidadBorradorEnDias"];
            this.permiteBorrador = _data["permiteBorrador"];
            this.tituloFinalizado = _data["tituloFinalizado"];
            this.subtituloFinalizado = _data["subtituloFinalizado"];
            this.checkboxAutoriza = _data["checkboxAutoriza"];
        }
    }

    static fromJS(data: any): PlantillaFormulario {
        data = typeof data === 'object' ? data : {};
        let result = new PlantillaFormulario();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["grupoId"] = this.grupoId;
        data["nombre"] = this.nombre;
        data["descripcion"] = this.descripcion;
        data["usuarioCreador"] = this.usuarioCreador;
        data["fechaCreacion"] = this.fechaCreacion ? this.fechaCreacion.toISOString() : <any>undefined;
        data["fechaCreacionCorto"] = this.fechaCreacionCorto;
        data["idFormularioRoles"] = this.idFormularioRoles;
        data["estaDisponible"] = this.estaDisponible;
        data["docsPorRamo"] = this.docsPorRamo;
        data["comentarios"] = this.comentarios;
        data["infoPoliza"] = this.infoPoliza;
        data["informacionAsegurado"] = this.informacionAsegurado;
        data["seccionPolizas"] = this.seccionPolizas;
        data["infoPersonal"] = this.infoPersonal;
        data["borradoLogico"] = this.borradoLogico;
        data["mcaPublico"] = this.mcaPublico;
        data["accesoAnonimo"] = this.accesoAnonimo;
        data["cargaMasiva"] = this.cargaMasiva;
        data["formularioGuid"] = this.formularioGuid;
        data["tipoAsignacion"] = this.tipoAsignacion;
        data["tipoAsignacionUsuarioGrupo"] = this.tipoAsignacionUsuarioGrupo;
        data["urlServicio"] = this.urlServicio;
        if (Array.isArray(this.stages)) {
            data["stages"] = [];
            for (let item of this.stages)
                data["stages"].push(item.toJSON());
        }
        if (Array.isArray(this.gruposAutocompletado)) {
            data["gruposAutocompletado"] = [];
            for (let item of this.gruposAutocompletado)
                data["gruposAutocompletado"].push(item.toJSON());
        }
        data["grupo"] = this.grupo;
        data["tipoAsignacionDescripcion"] = this.tipoAsignacionDescripcion;
        data["campoNombre"] = this.campoNombre;
        data["campoTipDocum"] = this.campoTipDocum;
        data["campoCodDocum"] = this.campoCodDocum;
        data["campoEmail"] = this.campoEmail;
        data["campoTelef"] = this.campoTelef;
        data["disponibilidadBorradorEnDias"] = this.disponibilidadBorradorEnDias;
        data["permiteBorrador"] = this.permiteBorrador;
        data["tituloFinalizado"] = this.tituloFinalizado;
        data["subtituloFinalizado"] = this.subtituloFinalizado;
        data["checkboxAutoriza"] = this.checkboxAutoriza;
        return data;
    }
}

export interface IPlantillaFormulario {
    id: number;
    grupoId: number;
    nombre: string;
    descripcion: string;
    usuarioCreador: string;
    fechaCreacion: Date;
    fechaCreacionCorto?: string | undefined;
    idFormularioRoles?: number | undefined;
    estaDisponible: boolean;
    docsPorRamo: boolean;
    comentarios: boolean;
    infoPoliza: boolean;
    informacionAsegurado: boolean;
    seccionPolizas: boolean;
    infoPersonal: boolean;
    borradoLogico: boolean;
    mcaPublico: boolean;
    accesoAnonimo: boolean;
    cargaMasiva: boolean;
    formularioGuid: string;
    tipoAsignacion?: number | undefined;
    tipoAsignacionUsuarioGrupo?: number | undefined;
    urlServicio?: string | undefined;
    stages?: Stage[] | undefined;
    gruposAutocompletado?: GrupoAutocompletado[] | undefined;
    grupo?: string | undefined;
    tipoAsignacionDescripcion?: string | undefined;
    campoNombre?: string | undefined;
    campoTipDocum?: string | undefined;
    campoCodDocum?: string | undefined;
    campoEmail?: string | undefined;
    campoTelef?: string | undefined;
    disponibilidadBorradorEnDias: number;
    permiteBorrador: boolean;
    tituloFinalizado?: string | undefined;
    subtituloFinalizado?: string | undefined;
    checkboxAutoriza: boolean;
}

export class GrupoAutocompletado implements IGrupoAutocompletado {
    id!: number;
    nombre?: string | undefined;
    plantillaFormulario?: PlantillaFormulario | undefined;
    plantillaFormularioId!: number;
    url?: string | undefined;
    parametrosAutocompletadoRemoto?: ParametrosAutocompletadoRemoto[] | undefined;

    constructor(data?: IGrupoAutocompletado) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nombre = _data["nombre"];
            this.plantillaFormulario = _data["plantillaFormulario"] ? PlantillaFormulario.fromJS(_data["plantillaFormulario"]) : <any>undefined;
            this.plantillaFormularioId = _data["plantillaFormularioId"];
            this.url = _data["url"];
            if (Array.isArray(_data["parametrosAutocompletadoRemoto"])) {
                this.parametrosAutocompletadoRemoto = [] as any;
                for (let item of _data["parametrosAutocompletadoRemoto"])
                    this.parametrosAutocompletadoRemoto!.push(ParametrosAutocompletadoRemoto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GrupoAutocompletado {
        data = typeof data === 'object' ? data : {};
        let result = new GrupoAutocompletado();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nombre"] = this.nombre;
        data["plantillaFormulario"] = this.plantillaFormulario ? this.plantillaFormulario.toJSON() : <any>undefined;
        data["plantillaFormularioId"] = this.plantillaFormularioId;
        data["url"] = this.url;
        if (Array.isArray(this.parametrosAutocompletadoRemoto)) {
            data["parametrosAutocompletadoRemoto"] = [];
            for (let item of this.parametrosAutocompletadoRemoto)
                data["parametrosAutocompletadoRemoto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGrupoAutocompletado {
    id: number;
    nombre?: string | undefined;
    plantillaFormulario?: PlantillaFormulario | undefined;
    plantillaFormularioId: number;
    url?: string | undefined;
    parametrosAutocompletadoRemoto?: ParametrosAutocompletadoRemoto[] | undefined;
}

export class ParametrosAutocompletadoRemoto implements IParametrosAutocompletadoRemoto {
    id!: number;
    tipo?: string | undefined;
    valorConstante?: string | undefined;
    idPlantillaCampoParametro?: number | undefined;
    plantillaCampos?: PlantillaCampos | undefined;
    nombreParametro?: string | undefined;
    esObligatorio!: boolean;
    disparaActualizacion!: boolean;
    grupoAutocompletado?: GrupoAutocompletado | undefined;
    grupoAutocompletadoId!: number;

    constructor(data?: IParametrosAutocompletadoRemoto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tipo = _data["tipo"];
            this.valorConstante = _data["valorConstante"];
            this.idPlantillaCampoParametro = _data["idPlantillaCampoParametro"];
            this.plantillaCampos = _data["plantillaCampos"] ? PlantillaCampos.fromJS(_data["plantillaCampos"]) : <any>undefined;
            this.nombreParametro = _data["nombreParametro"];
            this.esObligatorio = _data["esObligatorio"];
            this.disparaActualizacion = _data["disparaActualizacion"];
            this.grupoAutocompletado = _data["grupoAutocompletado"] ? GrupoAutocompletado.fromJS(_data["grupoAutocompletado"]) : <any>undefined;
            this.grupoAutocompletadoId = _data["grupoAutocompletadoId"];
        }
    }

    static fromJS(data: any): ParametrosAutocompletadoRemoto {
        data = typeof data === 'object' ? data : {};
        let result = new ParametrosAutocompletadoRemoto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipo"] = this.tipo;
        data["valorConstante"] = this.valorConstante;
        data["idPlantillaCampoParametro"] = this.idPlantillaCampoParametro;
        data["plantillaCampos"] = this.plantillaCampos ? this.plantillaCampos.toJSON() : <any>undefined;
        data["nombreParametro"] = this.nombreParametro;
        data["esObligatorio"] = this.esObligatorio;
        data["disparaActualizacion"] = this.disparaActualizacion;
        data["grupoAutocompletado"] = this.grupoAutocompletado ? this.grupoAutocompletado.toJSON() : <any>undefined;
        data["grupoAutocompletadoId"] = this.grupoAutocompletadoId;
        return data;
    }
}

export interface IParametrosAutocompletadoRemoto {
    id: number;
    tipo?: string | undefined;
    valorConstante?: string | undefined;
    idPlantillaCampoParametro?: number | undefined;
    plantillaCampos?: PlantillaCampos | undefined;
    nombreParametro?: string | undefined;
    esObligatorio: boolean;
    disparaActualizacion: boolean;
    grupoAutocompletado?: GrupoAutocompletado | undefined;
    grupoAutocompletadoId: number;
}

export class PlantillaCampos implements IPlantillaCampos {
    id!: number;
    idSeccion?: number | undefined;
    nombre!: string;
    descripcion!: string;
    tipo!: string;
    estaDisponible!: boolean;
    esSoloLectura!: boolean;
    borradoLogico!: boolean;
    longitud?: number | undefined;
    urlRemota?: string | undefined;
    esObligatorio!: boolean;
    esEditable!: boolean;
    esPrivado!: boolean;
    mostrarFueraDeSeccion!: boolean;
    requiereValidacionManual!: boolean;
    columnSize?: string | undefined;
    limiteFilas?: number | undefined;
    filasIniciales?: number | undefined;
    parametrosListaRemota?: ParametrosListaRemota[] | undefined;
    parametrosTabla?: ParametrosTabla[] | undefined;
    parametroTabla?: ParametrosTabla | undefined;
    tipoLongitud?: string | undefined;
    seccion?: string | undefined;
    disponible?: string | undefined;
    tipoCampoPersonalizado?: TipoCampoPersonalizado | undefined;
    atributosCampoPersonalizado?: AtributosCampoPersonalizado[] | undefined;
    contenidoNota?: string | undefined;

    constructor(data?: IPlantillaCampos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idSeccion = _data["idSeccion"];
            this.nombre = _data["nombre"];
            this.descripcion = _data["descripcion"];
            this.tipo = _data["tipo"];
            this.estaDisponible = _data["estaDisponible"];
            this.esSoloLectura = _data["esSoloLectura"];
            this.borradoLogico = _data["borradoLogico"];
            this.longitud = _data["longitud"];
            this.urlRemota = _data["urlRemota"];
            this.esObligatorio = _data["esObligatorio"];
            this.esEditable = _data["esEditable"];
            this.esPrivado = _data["esPrivado"];
            this.mostrarFueraDeSeccion = _data["mostrarFueraDeSeccion"];
            this.requiereValidacionManual = _data["requiereValidacionManual"];
            this.columnSize = _data["columnSize"];
            this.limiteFilas = _data["limiteFilas"];
            this.filasIniciales = _data["filasIniciales"];
            if (Array.isArray(_data["parametrosListaRemota"])) {
                this.parametrosListaRemota = [] as any;
                for (let item of _data["parametrosListaRemota"])
                    this.parametrosListaRemota!.push(ParametrosListaRemota.fromJS(item));
            }
            if (Array.isArray(_data["parametrosTabla"])) {
                this.parametrosTabla = [] as any;
                for (let item of _data["parametrosTabla"])
                    this.parametrosTabla!.push(ParametrosTabla.fromJS(item));
            }
            this.parametroTabla = _data["parametroTabla"] ? ParametrosTabla.fromJS(_data["parametroTabla"]) : <any>undefined;
            this.tipoLongitud = _data["tipoLongitud"];
            this.seccion = _data["seccion"];
            this.disponible = _data["disponible"];
            this.tipoCampoPersonalizado = _data["tipoCampoPersonalizado"] ? TipoCampoPersonalizado.fromJS(_data["tipoCampoPersonalizado"]) : <any>undefined;
            if (Array.isArray(_data["atributosCampoPersonalizado"])) {
                this.atributosCampoPersonalizado = [] as any;
                for (let item of _data["atributosCampoPersonalizado"])
                    this.atributosCampoPersonalizado!.push(AtributosCampoPersonalizado.fromJS(item));
            }
            this.contenidoNota = _data["contenidoNota"];
        }
    }

    static fromJS(data: any): PlantillaCampos {
        data = typeof data === 'object' ? data : {};
        let result = new PlantillaCampos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idSeccion"] = this.idSeccion;
        data["nombre"] = this.nombre;
        data["descripcion"] = this.descripcion;
        data["tipo"] = this.tipo;
        data["estaDisponible"] = this.estaDisponible;
        data["esSoloLectura"] = this.esSoloLectura;
        data["borradoLogico"] = this.borradoLogico;
        data["longitud"] = this.longitud;
        data["urlRemota"] = this.urlRemota;
        data["esObligatorio"] = this.esObligatorio;
        data["esEditable"] = this.esEditable;
        data["esPrivado"] = this.esPrivado;
        data["mostrarFueraDeSeccion"] = this.mostrarFueraDeSeccion;
        data["requiereValidacionManual"] = this.requiereValidacionManual;
        data["columnSize"] = this.columnSize;
        data["limiteFilas"] = this.limiteFilas;
        data["filasIniciales"] = this.filasIniciales;
        if (Array.isArray(this.parametrosListaRemota)) {
            data["parametrosListaRemota"] = [];
            for (let item of this.parametrosListaRemota)
                data["parametrosListaRemota"].push(item.toJSON());
        }
        if (Array.isArray(this.parametrosTabla)) {
            data["parametrosTabla"] = [];
            for (let item of this.parametrosTabla)
                data["parametrosTabla"].push(item.toJSON());
        }
        data["parametroTabla"] = this.parametroTabla ? this.parametroTabla.toJSON() : <any>undefined;
        data["tipoLongitud"] = this.tipoLongitud;
        data["seccion"] = this.seccion;
        data["disponible"] = this.disponible;
        data["tipoCampoPersonalizado"] = this.tipoCampoPersonalizado ? this.tipoCampoPersonalizado.toJSON() : <any>undefined;
        if (Array.isArray(this.atributosCampoPersonalizado)) {
            data["atributosCampoPersonalizado"] = [];
            for (let item of this.atributosCampoPersonalizado)
                data["atributosCampoPersonalizado"].push(item.toJSON());
        }
        data["contenidoNota"] = this.contenidoNota;
        return data;
    }
}

export interface IPlantillaCampos {
    id: number;
    idSeccion?: number | undefined;
    nombre: string;
    descripcion: string;
    tipo: string;
    estaDisponible: boolean;
    esSoloLectura: boolean;
    borradoLogico: boolean;
    longitud?: number | undefined;
    urlRemota?: string | undefined;
    esObligatorio: boolean;
    esEditable: boolean;
    esPrivado: boolean;
    mostrarFueraDeSeccion: boolean;
    requiereValidacionManual: boolean;
    columnSize?: string | undefined;
    limiteFilas?: number | undefined;
    filasIniciales?: number | undefined;
    parametrosListaRemota?: ParametrosListaRemota[] | undefined;
    parametrosTabla?: ParametrosTabla[] | undefined;
    parametroTabla?: ParametrosTabla | undefined;
    tipoLongitud?: string | undefined;
    seccion?: string | undefined;
    disponible?: string | undefined;
    tipoCampoPersonalizado?: TipoCampoPersonalizado | undefined;
    atributosCampoPersonalizado?: AtributosCampoPersonalizado[] | undefined;
    contenidoNota?: string | undefined;
}

export class ParametrosListaRemota implements IParametrosListaRemota {
    id!: number;
    idPlantillaCampoParametro!: number;
    nombreParametro?: string | undefined;
    esObligatorio!: boolean;
    disparaActualizacion!: boolean;
    idPlantillaListaRemota!: number;
    plantillaListaRemota?: PlantillaCampos | undefined;

    constructor(data?: IParametrosListaRemota) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idPlantillaCampoParametro = _data["idPlantillaCampoParametro"];
            this.nombreParametro = _data["nombreParametro"];
            this.esObligatorio = _data["esObligatorio"];
            this.disparaActualizacion = _data["disparaActualizacion"];
            this.idPlantillaListaRemota = _data["idPlantillaListaRemota"];
            this.plantillaListaRemota = _data["plantillaListaRemota"] ? PlantillaCampos.fromJS(_data["plantillaListaRemota"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ParametrosListaRemota {
        data = typeof data === 'object' ? data : {};
        let result = new ParametrosListaRemota();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idPlantillaCampoParametro"] = this.idPlantillaCampoParametro;
        data["nombreParametro"] = this.nombreParametro;
        data["esObligatorio"] = this.esObligatorio;
        data["disparaActualizacion"] = this.disparaActualizacion;
        data["idPlantillaListaRemota"] = this.idPlantillaListaRemota;
        data["plantillaListaRemota"] = this.plantillaListaRemota ? this.plantillaListaRemota.toJSON() : <any>undefined;
        return data;
    }
}

export interface IParametrosListaRemota {
    id: number;
    idPlantillaCampoParametro: number;
    nombreParametro?: string | undefined;
    esObligatorio: boolean;
    disparaActualizacion: boolean;
    idPlantillaListaRemota: number;
    plantillaListaRemota?: PlantillaCampos | undefined;
}

export class ParametrosTabla implements IParametrosTabla {
    id!: number;
    idPlantillaCampo!: number;
    plantillaCampo?: PlantillaCampos | undefined;
    valorPorDefecto?: string | undefined;
    idPlantillaCampoTabla!: number;
    plantillaCampoTabla?: PlantillaCampos | undefined;
    orden!: number;
    eliminado!: boolean;

    constructor(data?: IParametrosTabla) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idPlantillaCampo = _data["idPlantillaCampo"];
            this.plantillaCampo = _data["plantillaCampo"] ? PlantillaCampos.fromJS(_data["plantillaCampo"]) : <any>undefined;
            this.valorPorDefecto = _data["valorPorDefecto"];
            this.idPlantillaCampoTabla = _data["idPlantillaCampoTabla"];
            this.plantillaCampoTabla = _data["plantillaCampoTabla"] ? PlantillaCampos.fromJS(_data["plantillaCampoTabla"]) : <any>undefined;
            this.orden = _data["orden"];
            this.eliminado = _data["eliminado"];
        }
    }

    static fromJS(data: any): ParametrosTabla {
        data = typeof data === 'object' ? data : {};
        let result = new ParametrosTabla();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idPlantillaCampo"] = this.idPlantillaCampo;
        data["plantillaCampo"] = this.plantillaCampo ? this.plantillaCampo.toJSON() : <any>undefined;
        data["valorPorDefecto"] = this.valorPorDefecto;
        data["idPlantillaCampoTabla"] = this.idPlantillaCampoTabla;
        data["plantillaCampoTabla"] = this.plantillaCampoTabla ? this.plantillaCampoTabla.toJSON() : <any>undefined;
        data["orden"] = this.orden;
        data["eliminado"] = this.eliminado;
        return data;
    }
}

export interface IParametrosTabla {
    id: number;
    idPlantillaCampo: number;
    plantillaCampo?: PlantillaCampos | undefined;
    valorPorDefecto?: string | undefined;
    idPlantillaCampoTabla: number;
    plantillaCampoTabla?: PlantillaCampos | undefined;
    orden: number;
    eliminado: boolean;
}

export class TipoCampoPersonalizado implements ITipoCampoPersonalizado {
    id!: number;
    nombre?: string | undefined;
    descripcion?: string | undefined;
    tipo?: string | undefined;
    borradoLogico!: boolean;
    plantillaCampos?: PlantillaCampos[] | undefined;

    constructor(data?: ITipoCampoPersonalizado) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nombre = _data["nombre"];
            this.descripcion = _data["descripcion"];
            this.tipo = _data["tipo"];
            this.borradoLogico = _data["borradoLogico"];
            if (Array.isArray(_data["plantillaCampos"])) {
                this.plantillaCampos = [] as any;
                for (let item of _data["plantillaCampos"])
                    this.plantillaCampos!.push(PlantillaCampos.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TipoCampoPersonalizado {
        data = typeof data === 'object' ? data : {};
        let result = new TipoCampoPersonalizado();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nombre"] = this.nombre;
        data["descripcion"] = this.descripcion;
        data["tipo"] = this.tipo;
        data["borradoLogico"] = this.borradoLogico;
        if (Array.isArray(this.plantillaCampos)) {
            data["plantillaCampos"] = [];
            for (let item of this.plantillaCampos)
                data["plantillaCampos"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITipoCampoPersonalizado {
    id: number;
    nombre?: string | undefined;
    descripcion?: string | undefined;
    tipo?: string | undefined;
    borradoLogico: boolean;
    plantillaCampos?: PlantillaCampos[] | undefined;
}

export class AtributosCampoPersonalizado implements IAtributosCampoPersonalizado {
    id!: number;
    idPlantillaCampo!: number;
    nombreAtributo?: string | undefined;
    valorAtributo?: string | undefined;

    constructor(data?: IAtributosCampoPersonalizado) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idPlantillaCampo = _data["idPlantillaCampo"];
            this.nombreAtributo = _data["nombreAtributo"];
            this.valorAtributo = _data["valorAtributo"];
        }
    }

    static fromJS(data: any): AtributosCampoPersonalizado {
        data = typeof data === 'object' ? data : {};
        let result = new AtributosCampoPersonalizado();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idPlantillaCampo"] = this.idPlantillaCampo;
        data["nombreAtributo"] = this.nombreAtributo;
        data["valorAtributo"] = this.valorAtributo;
        return data;
    }
}

export interface IAtributosCampoPersonalizado {
    id: number;
    idPlantillaCampo: number;
    nombreAtributo?: string | undefined;
    valorAtributo?: string | undefined;
}

export enum Strategy {
    SIN_ESTRATEGIA = 0,
    UNICO = 1,
    ROUND_ROBIN = 2,
    SUPERIOR = 3,
    PLANTILLA = 4,
    USUARIO_PREVIO = 5,
    CREADOR = 6,
    MANUAL = 7,
    GRUPO_BASADO_EN_ROL = 8,
    ASIGNACION_REMOTA = 9,
}

export class WebhookConfiguration implements IWebhookConfiguration {
    id!: string;
    plantillaId!: number;
    stageId!: number;
    maxRetry!: number;
    isDeleted!: boolean;
    description?: string | undefined;
    url?: string | undefined;
    stage?: Stage | undefined;
    creatorUser?: string | undefined;
    creationDate!: Date
    transitionId?: number | undefined;
    version?: number | undefined;

    constructor(data?: IWebhookConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plantillaId = _data["plantillaId"];
            this.stageId = _data["stageId"];
            this.maxRetry = _data["maxRetry"];
            this.isDeleted = _data["isDeleted"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.stage = _data["stage"] ? Stage.fromJS(_data["stage"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.transitionId = _data["transitionId"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): WebhookConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plantillaId"] = this.plantillaId;
        data["stageId"] = this.stageId;
        data["maxRetry"] = this.maxRetry;
        data["isDeleted"] = this.isDeleted;
        data["description"] = this.description;
        data["url"] = this.url;
        data["stage"] = this.stage ? this.stage.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWebhookConfiguration {
    id: string;
    plantillaId: number;
    stageId: number;
    maxRetry: number;
    isDeleted: boolean;
    description?: string | undefined;
    url?: string | undefined;
    stage?: Stage | undefined;
    creatorUser?: string | undefined;
    creationDate: Date;
}

export enum TipoLista {
    USUARIOS = 0,
    ROL = 1,
    GRUPO_BASADO_EN_ROL = 2,
}

export enum TipoNotificacion {
    CORREO = 1,
    SMS = 2,
}

export enum DestinatarioEnum {
    CREADOR = 1,
    ASIGNADO = 2,
    FIJO = 3,
}

export class RespuestaPredeterminada implements IRespuestaPredeterminada {
    id!: number;
    titulo?: string | undefined;
    contenido?: string | undefined;
    transitionId!: number;
    usuarioPuedeEditar!: boolean;

    constructor(data?: IRespuestaPredeterminada) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titulo = _data["titulo"];
            this.contenido = _data["contenido"];
            this.transitionId = _data["transitionId"];
            this.usuarioPuedeEditar = _data["usuarioPuedeEditar"];
        }
    }

    static fromJS(data: any): RespuestaPredeterminada {
        data = typeof data === 'object' ? data : {};
        let result = new RespuestaPredeterminada();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titulo"] = this.titulo;
        data["contenido"] = this.contenido;
        data["transitionId"] = this.transitionId;
        data["usuarioPuedeEditar"] = this.usuarioPuedeEditar;
        return data;
    }
}

export interface IRespuestaPredeterminada {
    id: number;
    titulo?: string | undefined;
    contenido?: string | undefined;
    transitionId: number;
    usuarioPuedeEditar: boolean;
}

export class Select2Result implements ISelect2Result {
    status?: string | undefined;
    results?: Select2[] | undefined;
    msg?: string | undefined;

    constructor(data?: ISelect2Result) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Select2.fromJS(item));
            }
            this.msg = _data["msg"];
        }
    }

    static fromJS(data: any): Select2Result {
        data = typeof data === 'object' ? data : {};
        let result = new Select2Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        return data;
    }
}

export interface ISelect2Result {
    status?: string | undefined;
    results?: Select2[] | undefined;
    msg?: string | undefined;
}

export class Select2 implements ISelect2 {
    id?: string | undefined;
    text?: string | undefined;

    constructor(data?: ISelect2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): Select2 {
        data = typeof data === 'object' ? data : {};
        let result = new Select2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface ISelect2 {
    id?: string | undefined;
    text?: string | undefined;
}

export class WebhookConfigurationCreateDto implements IWebhookConfigurationCreateDto {
    plantillaId!: number;
    stageId!: number;
    maxRetry!: number;
    description?: string | undefined;
    url?: string | undefined;
    transitionId?: number | undefined;
    version?: number | undefined;

    constructor(data?: IWebhookConfigurationCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plantillaId = _data["plantillaId"];
            this.stageId = _data["stageId"];
            this.maxRetry = _data["maxRetry"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.transitionId = _data["transitionId"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): WebhookConfigurationCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookConfigurationCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plantillaId"] = this.plantillaId;
        data["stageId"] = this.stageId;
        data["maxRetry"] = this.maxRetry;
        data["description"] = this.description;
        data["url"] = this.url;
        data["transitionId"] = this.transitionId;
        data["version"] = this.version;
        return data;
    }
}

export interface IWebhookConfigurationCreateDto {
    plantillaId: number;
    stageId: number;
    maxRetry: number;
    description?: string | undefined;
    url?: string | undefined;
    transitionId?: number | undefined;
    version?: number | undefined;
}

export class WebhookConfigurationUpdateDto implements IWebhookConfigurationUpdateDto {
    description?: string | undefined;
    maxRetry!: number;
    transitionId?: number | undefined;

    constructor(data?: IWebhookConfigurationUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.maxRetry = _data["maxRetry"];
            this.transitionId = _data["transitionId"];
        }
    }

    static fromJS(data: any): WebhookConfigurationUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookConfigurationUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["maxRetry"] = this.maxRetry;
        data["transitionId"] = this.transitionId;
        return data;
    }
}

export interface IWebhookConfigurationUpdateDto {
    description?: string | undefined;
    maxRetry: number;
    transitionId?: number | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}